import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { InternalErrorResponse } from '@/services/transport/types'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiDealsDealNotFoundError extends TmApiClientError<InternalErrorResponse> {
  public name = 'TmApiDealsDealNotFoundError'

  protected override code: TmTransportHttpErrorCode = 404

  public shouldBeMonitored(): boolean {
    return false
  }
}
